import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // Import loga
import facebookLogo from '../assets/facebook-logo.png'; // Import Facebook logo
import './Branch2.css'; // Import styles for Branch2
import Footer from './Footer'; // Import Footer komponenty


const Branch2 = () => {
  const [isSummer, setIsSummer] = useState(false);
  const [note, setNote] = useState(''); // State pro poznámku

  // Automaticky detekuje, zda je léto nebo zima
  useEffect(() => {
    const today = new Date();
    const startSummer = new Date(today.getFullYear(), 3, 15); // 15. dubna
    const endSummer = new Date(today.getFullYear(), 8, 15); // 15. září
    if (today >= startSummer && today <= endSummer) {
      setIsSummer(true);
    } else {
      setIsSummer(false);
    }

    fetchNote(); // Načíst poznámku při načtení komponenty
  }, []);

  const fetchNote = async () => {
    try {
      const response = await fetch('/fetchNoteHoly.php'); // Načtení poznámky z PHP
      const data = await response.json();
      setNote(data.note); // Nastavení poznámky do stavu
    } catch (error) {
      console.error('Chyba při načítání poznámky:', error);
    }
  };

  return (
    <div className="branch2 min-h-screen flex flex-col">
      {/* Header sekce s logem */}
      <header className="branch2-header h-[20vh] flex items-center justify-center">
        <Link to="/" className="branch2-logo-link">
          <img src={logo} alt="Pizzeria Logo" className="branch2-logo max-w-full h-auto" />
        </Link>
      </header>

      {/* Titulek */}
      <div className="branch2-title-container text-center mt-4">
        <h1 className="branch2-title text-3xl font-bold text-green-700">Holýšov PizzaPoint</h1>

        {/* Zobrazení poznámky, pokud existuje */}
        {note && (
          <div className="branch2-note bg-yellow-100 text-yellow-700 p-4 mt-4">
            <p>{note}</p>
          </div>
        )}
      </div>

      {/* Hlavní obsah */}
      <main className="branch2-content flex-grow p-4">
        {/* Dva sloupce: Adresa a Rozvoz */}
        <div className="flex flex-col md:flex-row gap-8">
          {/* Levý sloupec - Adresa, telefon, otvírací doba */}
          <div className="branch2-column w-full md:w-1/2">
            <h2 className="text-xl font-bold">Adresa</h2>
            <a className="cervena2 text-green-600 font-bold" href="https://maps.google.com/?q=Táborová 758, Holýšov" target="_blank" rel="noopener noreferrer">
              Táborová 758, Holýšov
            </a>
            <h2 className="mt-4 text-xl font-bold">Telefon</h2>
            <a className="cervena2 text-green-600 font-bold" href="tel:+420733521655">+420 733 521 655</a>

            <h2 className="mt-4 text-xl font-bold">Otvírací doba</h2>
            {isSummer ? (
              <div>
                <p>Po-Čt: 11:00 - 20:30</p>
                <p>Pá: 11:00 - 21:00</p>
                <p>So: 12:00 - 21:00</p>
                <p>Ne: 12:00 - 20:30</p>
              </div>
            ) : (
              <div>
                <p>Po-Čt: 11:00 - 20:00</p>
                <p>Pá: 11:00 - 20:30</p>
                <p>So: 12:00 - 20:30</p>
                <p>Ne: 12:00 - 20:00</p>
              </div>
            )}
            <a href="https://www.facebook.com/pizzapoint.holysov" target="_blank" rel="noopener noreferrer">
              <img src={facebookLogo} alt="Facebook" className="facebook-logo w-10 mt-4" />
            </a>
          </div>

          {/* Pravý sloupec - Rozvoz */}
          <div className="branch2-column w-full md:w-1/2">
  <h2 className="text-xl font-bold">Rozvoz Holýšov denně od 17:00</h2>
  <h2 className="text-xl font-bold">Poslední objednávky 30 minut před koncem pracovní doby.</h2>
  <div className="flex justify-center my-4">
              <a
                href="https://pizza-point-restaurace-stankov.order.app.hd.digital/menus"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-green-700 transition-colors"
              >
                Objednat a vyzvednout
              </a>
            </div>

  <div className="branch2-delivery-info mt-4">
    <table className="table-auto w-full text-left border-collapse border border-green-600">
      <thead className="bg-green-100">
        <tr>
          <th className="px-4 py-2 border border-green-600">Zóna</th>
          <th className="px-4 py-2 border border-green-600">Min. objednávka</th>
          <th className="px-4 py-2 border border-green-600">Popis</th>
          <th className="px-4 py-2 border border-green-600">Dovoz</th>
          <th className="px-4 py-2 border border-green-600">Zdarma při objednávce</th>
        </tr>
      </thead>
      <tbody>
        {/* Zóna 1 */}
        <tr>
          <td className="px-4 py-2 border border-green-600">Zóna 1</td>
          <td className="px-4 py-2 border border-green-600">250,- Kč</td>
          <td className="px-4 py-2 border border-green-600">Holýšov</td>
          <td className="px-4 py-2 border border-green-600">
            <span className="text-white bg-green-600 px-2 rounded">35,- Kč</span>
          </td>
          <td className="px-4 py-2 border border-green-600">
            <span className="text-green-600">nad 350,- Kč</span> <strong className="font-bold text-green-600">ZDARMA</strong>
          </td>
        </tr>
        {/* Zóna 2 */}
        <tr>
          <td className="px-4 py-2 border border-green-600">Zóna 2</td>
          <td className="px-4 py-2 border border-green-600">350,- Kč</td>
          <td className="px-4 py-2 border border-green-600">Dolní Kamenice, Horní Kamenice, Kvíčovice, Neuměř, Všekary, Ohučov, Štichov</td>
          <td className="px-4 py-2 border border-green-600">
            <span className="text-white bg-green-600 px-2 rounded">40,- Kč</span>
          </td>
          <td className="px-4 py-2 border border-green-600">
            <span className="text-green-600">nad 450,- Kč</span> <strong className="font-bold text-green-600">ZDARMA</strong>
          </td>
        </tr>
        {/* Zóna 3 */}
        <tr>
          <td className="px-4 py-2 border border-green-600">Zóna 3</td>
          <td className="px-4 py-2 border border-green-600">400,- Kč</td>
          <td className="px-4 py-2 border border-green-600">Hradec u Stoda, Stod, Lelov</td>
          <td className="px-4 py-2 border border-green-600">
            <span className="text-white bg-green-600 px-2 rounded">45,- Kč</span>
          </td>
          <td className="px-4 py-2 border border-green-600">
            <span className="text-green-600">nad 550,- Kč</span> <strong className="font-bold text-green-600">ZDARMA</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
        </div>
         {/* Menu sekce */}
         <div className="flex flex-wrap branch3-menu">
  {/* First Column */}
  <div className="w-full md:w-1/3 p-4 " translate="no">
    <h2 className="font-bold text-green-600">PIZZA</h2>
    <p className='text-right'> standart (cca 30cm) / xxl (cca 40cm)</p>
    <ul className="space-y-2">
    <li><span className='text-green-500'>1) PIZZA PANE</span> <span>80,- / 145,-</span></li>
<li>(pizza chléb s česnekem, olivovým olejem a sýrem)</li>
<li><span className='text-green-500'>2) MARGHERITA</span> <span>120,- / 185,-</span></li>
<li>(Rajčatová směs, sýr)</li>
<li><span className='text-green-500'>3) PROSCIUTTO</span> <span>140,- / 205,-</span></li>
<li>(Rajčatová směs, sýr, šunka)</li>
<li><span className='text-green-500'>4) SALAMI</span> <span>140,- / 205,-</span></li>
<li>(Rajčatová směs, sýr, salám)</li>
<li><span className='text-green-500'>5) MILANESE</span> <span>145,- / 210,-</span></li>
<li>(Rajčatová směs, sýr, salám, šunka, žampiony)</li>
<li><span className='text-green-500'>6) DIABOLO</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, sýr, salám, tuňák, paprika, feferonky, chili)</li>
<li><span className='text-green-500'>7) TOSCANA</span> <span>150,- / 215,-</span></li>
<li>(Smetana, sýr, salám, šunka, paprika, žampiony)</li>
<li><span className='text-green-500'>8) TONNO</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, sýr, tuňák, olivy, cibule)</li>
<li><span className='text-green-500'>9) QUATTRO FORMAGGI</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, 4 druhy sýrů)</li>
<li><span className='text-green-500'>10) PROSCIUTTO DI PARMA</span> <span>160,- / 225,-</span></li>
<li>(Rajčatová směs, sýr, špenát, žampiony, česnek, parmská šunka)</li>
<li><span className='text-green-500'>11) POLLO</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, sýr, kuřecí maso, paprika)</li>
<li><span className='text-green-500'>12) POLLO TUTTI</span> <span>155,- / 220,-</span></li>
<li>(Rajčatová směs, sýr, kuřecí maso, špenát, slanina)</li>
<li><span className='text-green-500'>13) VEGETARIANA</span> <span>145,- / 210,-</span></li>
<li>(Rajčatová směs, sýr, žampiony, špenát, brokolice, kukuřice)</li>
<li><span className='text-green-500'>14) HAWAII</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, sýr, šunka, ananas)</li>
    </ul>
  </div>

  {/* Second Column */}
  <div className="w-full md:w-1/3 p-4" translate="no">
  <p className='text-right zmizet'> standart (cca 30cm) / xxl (cca 40cm)</p>
    <ul className="space-y-2">
    <li><span className='text-green-500'>16) PADRE PEPPE</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, sýr, salám, feferonky, olivy, cibule, chili)</li>
<li><span className='text-green-500'>17) ROMANO</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, sýr, šunka, salám, žampiony, feferonky, mozzarela)</li>
<li><span className='text-green-500'>18) SPECIALLE</span> <span>150,- / 215,-</span></li>
<li>(Sýr, salám, anglická slanina, cibule, smetana, majoránka)</li>
<li><span className='text-green-500'>19) FIORINO</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, sýr, šunka, špenát, vejce, cibule)</li>
<li><span className='text-green-500'>20) LIVORNO</span> <span>150,- / 215,-</span></li>
<li>(Rajčatová směs, sýr, anglická slanina, cibule)</li>
<li><span className='text-green-500'>21) REGINA</span> <span>145,- / 210,-</span></li>
<li>(Rajčatová směs, sýr, šunka, žampiony)</li>
<li><span className='text-green-500'>22) DELICETO</span> <span>155,- / 220,-</span></li>
<li>(Rajčatová směs, sýr, klobása, slanina, feferonky, cibule, česnek)</li>
<li><span className='text-green-500'>23) POLLINA</span> <span>155,- / 220,-</span></li>
<li>(Sýr, smetana, kuřecí maso, niva)</li>
<li><span className='text-green-500'>24) RIBERA</span> <span>160,- / 225,-</span></li>
<li>(Rajčatová směs, sýr, kuřecí maso, klobása, slanina)</li>
<li><span className='text-green-500'>25) CRANBERRIES</span> <span>160,- / 225,-</span></li>
<li>(Smetana, sýr, šunka, niva, brusinky)</li>
<li><span className='text-green-500'>26) STRAPPATO</span> <span>160,- / 225,-</span></li>
<li>(Rajčatová směs, sýr, trhané vepř. maso, beraní rohy, BBQ omáčka, cheddar)</li>
    </ul>
    <p className='text-sm mt-4'>Pizzu vám rádi na přání zdarma dochutíme česnekem nebo chilli</p>
    <ul className="space-y-2 mt-4">
      <li><span className='text-green-500'>EXTRA PŘÁNÍ</span> <span>vejce, zelenina, ananas, cibule</span> <span>10,-</span></li>
      <li><span className='text-green-500'>EXTRA PŘÁNÍ</span> <span>šunka, salám, slanina, klobása</span> <span>20,-</span></li>
      <li><span className='text-green-500'>EXTRA PŘÁNÍ</span> <span>kuřecí maso, parmská šunka</span> <span>30,-</span></li>
      <li><span className='text-green-500'>EXTRA PŘÁNÍ</span> <span>tuňák</span> <span>30,-</span></li>
      <li><span className='text-green-500'>EXTRA PŘÁNÍ</span> <span>sýr</span> <span>20,-</span></li>
    </ul>
  </div>

  {/* Third Column */}
  <div className="w-full md:w-1/3 p-4" translate="no">
    <h2 className="text-green-600 font-bold">TĚSTOVINY</h2>
    <p className="text-green-500">Gnocchi</p>
    <ul className="space-y-2">
      <li><span className='text-green-500'>1) CON POLLO</span> <span>150,-</span></li>
      <li>(kuřecí maso, špenát, smetana, česnek, sýr)</li>
      <li><span className='text-green-500'>2) ALLA PANNA</span> <span>145,-</span></li>
      <li>(šunka, žampiony, smetana, rajčatová omáčka)</li>
      <li><span className='text-green-500'>3) QUATTRO FORMAGGI</span> <span>145,-</span></li>
      <li>(smetana, čtyři druhy sýrů)</li>
      <li><span className='text-green-500'>4) FUNGHI</span> <span>150,-</span></li>
      <li>(kuřecí maso, žampiony, cibule, smetana)</li>
    </ul>
    <h2 className="text-green-600 font-bold mt-6">OSTATNÍ</h2>
    <ul className="space-y-2">
      <li><span className='text-green-500'>Tortila Strips</span> <span>84,-</span> <span>115,- MAXI</span></li>
      <li>(kuřecí stripsy, zelenina, dresing)</li>
      <li><span className='text-green-500'>Tortila sýrová</span> <span>84,-</span> <span>115,- MAXI</span></li>
      <li>(kousky smaženého sýra, rajčata, salát, dresing)</li>
      <li><span className='text-green-500'>Tortila MIX</span> <span>84,-</span> <span>115,- MAXI</span></li>
      <li>(kuřecí stripsy, kousky smaž. sýra, salát, rajč., dresing)</li>
      <li><span className='text-green-500'>Tortila s trhaným vepř. masem</span> <span>125,-</span></li>
      <li>(trhané maso, ledový salát, rajče, cibule, BBQ omáčka)</li>
      <li><span className='text-green-500'>Hamburgery</span> - hovězí<span>95,-</span></li>
      <li><span className="zmizet">Hamburgery</span> - kuřecí <span>60,-</span></li>
      <li><span className="zmizet">Hamburgery</span> - sýrový <span>70,-</span></li>
      <li><span className="zmizet">Hamburgery</span> - řízkový <span>70,-</span></li>
      <li><span className="zmizet">Hamburgery</span> - hermelínový <span>70,-</span></li>   
      <li><span className="zmizet">Hamburgery</span> - s trhaným vepř. masem <span>95,-</span></li>
      <li><span className='text-green-500'>Kuřecí nugety</span> <span>100,-</span></li>
      <li><span className='text-green-500'>Smažený sýr</span> <span>95,-</span></li>
      <li><span className='text-green-500'>Smažený hermelín</span> <span>100,-</span></li>
      <li><span className='text-green-500'>Smažený kuřecí řízek</span> <span>105,-</span></li>
      <li><span className='text-green-500'>Hranolky</span> <span>40,-</span></li>
      <li><span className='text-green-500'>Americké brambory</span> <span>46,-</span></li>
      <li><span className='text-green-500'>Krokety</span> <span>48,-</span></li>
      <li><span className='text-green-500'>Tatarská omáčka, Kečup</span> <span>15,-</span></li>
    </ul>
  </div>
  <div className="w-full md:w-1/3 p-4" translate="no">
    <h2 className="text-green-600 font-bold">SALÁTY</h2>
    <ul className="space-y-2">
      <li><span className='text-green-500'>MICHANÝ SALÁT</span> <span>80,-</span></li>
      <li>(salát, rajčata, okurka, paprika)</li>
      <li><span className='text-green-500'>MICHANÝ SALÁT SE ŠUNKOU A SÝREM</span> <span>120,-</span></li>
      <li>(salát, rajčata, okurka, paprika + šunka, sýr)</li>
      <li><span className='text-green-500'>MICHANÝ SALÁT S TUŇÁKEM</span> <span>135,-</span></li>
      <li>(salát, rajčata, okurka, paprika + tuňák, cibule, olivy, vejce)</li>
      <li><span className='text-green-500'>MICHANÝ SALÁT S KUŘECÍM MASEM</span> <span>135,-</span></li>
      <li>(salát, rajčata, okurka, paprika + restované kuřecí maso)</li>
      <li><span className='text-green-500'>BALKÁN</span> <span>90,-</span></li>
      <li>(salát, rajčata, okurka, paprika + balkán. sýr)</li>
    </ul>
  </div>
  <div className="w-full md:w-1/3 p-4" translate="no">
  <h2 className="text-green-600 font-bold">NEALKO 1l</h2>
  <ul className="space-y-2">
    <li><span className='text-green-500'>Coca Cola 1L</span> <span>44,-</span></li>
    <li><span className='text-green-500'>Coca Cola Zero 1L</span> <span>44,-</span></li>
    <li><span className='text-green-500'>Fanta 1L</span> <span>44,-</span></li>
    <li><span className='text-green-500'>Sprite 1L</span> <span>44,-</span></li>
  </ul>
  <h2 className="text-green-600 font-bold">NEALKO 0.5l</h2>
  <ul className="space-y-2">
    <li><span className='text-green-500'>Coca Cola 0,5L</span> <span>35,-</span></li>
    <li><span className='text-green-500'>Coca Cola Zero 0,5L</span> <span>35,-</span></li>
    <li><span className='text-green-500'>Fanta 0,5L</span> <span>35,-</span></li>
    <li><span className='text-green-500'>Fanta Shokata 0,5L</span> <span>35,-</span></li>
    <li><span className='text-green-500'>Sprite 0,5L</span> <span>35,-</span></li>
    <li><span className='text-green-500'>Ledový čaj 0,5L</span> <span>35,-</span></li>
    <li><span className='text-green-500'>Voda neperlivá 0,5L</span> <span>25,-</span></li>
    <li><span className='text-green-500'>Voda jemně perlivá 0,5L</span> <span>25,-</span></li>
    <li><span className='text-green-500'>Bizonáda (ovocná limonáda)</span> <span>35,-</span></li>
  </ul>
</div>
<div className="w-full md:w-1/3 p-4" translate="no">
  <h2 className="text-green-600 font-bold">PIVO</h2>
  <ul className="space-y-2">
  <li><span className='text-green-500'>Gambrinus plech 0,5L</span> <span>35,-</span></li>
    <li><span className='text-green-500'>Pilsner Urquell plech 0,5L</span> <span>50,-</span></li>
    <h2 className="text-green-500 font-bold">Pivo z  pivovaru Bizon Čížice</h2>
    <li><span className='text-green-500'>Chasník</span> <span>45,-</span></li>
    <li><span className='text-green-500'>Kameník</span> <span>45,-</span></li>
    <li><span className='text-green-500'>Tap Tap</span> <span>48,-</span></li>
    <li><span className='text-green-500'>Nostalgie</span> <span>52,-</span></li>
    <li><span className='text-green-500'>Karolína Světlá</span> <span>52,-</span></li>
    <li><span className='text-green-500'>Hrobník</span> <span>52,-</span></li>
    <li><span className='text-green-500'>Space Ale</span> <span>52,-</span></li>
    <li><span className='text-green-500'>Citra Art Ale</span> <span>55,-</span></li>
    <li><span className='text-green-500'>Freedom Ipa</span> <span>55,-</span></li>
    <li><span className='text-green-500'>Aparát</span> <span>55,-</span></li>
    <li><span className='text-green-500'>Klíšťák</span> <span>55,-</span></li>
    <li><span className='text-green-500'>Black Stone</span> <span>65,-</span></li>
  </ul>
</div>
</div>
      </main>
      <Footer />
    </div>
  );
};

export default Branch2;